<template>
  <div class="container mx-auto my-8 px-4 md:px-0">
    <base-form v-if="sanmer" :do="save" :v-errors="error" class="flex flex-col md:flex-row md:-mx-4">

      <div class="w-full bg-white content shadow mb-6 md:mb-0 md:mx-4 md:w-2/3">
        <div class="group">
          <div class="fields flex flex-col w-full p-6">
            <div class="flex flex-wrap mx-0 md:-mx-2">
              <text-input class="w-full md:w-1/2 md:px-2" label="Naam" name="name" type="text"
                v-model="sanmer.name"
                v-validate="'required'"
                data-vv-as="Naam"
                :error="errors.first('name')"
                :has-permission="true"
                :required="true"
              ></text-input>
            </div>
          </div>
        </div>
        <div class="flex w-full px-6 py-6 bg-grey-lightest border-t border-grey-lighter flex items-center">
          <button v-if="!isNew" tabindex="-1" type="button" class="text-sm text-red hover:underline" @click="destroy()">
            <span>Verwijder</span>
            <span class="hidden md:inline ml-1">Saneerder</span>
          </button>
          <button type="submit" class="btn py-3 text-sm text-white bg-green-dark font-semibold ml-auto">
            <span>{{ isNew ? 'Bewaren' : 'Wijzig' }}</span>
            <span class="hidden md:inline ml-1">Saneerder</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col w-full z-0 md:mx-4 md:w-1/3" v-if="sanmer.created_at">
        <!-- CREATED -->
        <div class="w-full mb-4 shadow" style="background-color: #e7eef3;">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gemaakt op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ sanmer.created_at }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gewijzigd op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ sanmer.updated_at }}</span>
            </div>
          </div>
        </div>
      </div>

    </base-form>
    <base-notification
      :type="notification.type"
      :message.sync="notification.message"
    ></base-notification>
  </div>
</template>

<script>
import SanmerService from '@/services/sanmer';
import SanmerPerimeters from '@/perimeters/sanmer';

import BaseForm from '@/components/globals/BaseForm';
import BaseNotification from '@/components/globals/BaseNotification';
import TextInput from '@/components/inputs/Text';

export default {
  name: 'SanmerEdit',
  perimeters: [SanmerPerimeters],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    BaseNotification,
    TextInput
  },
  data() {
    return {
      sanmer: null,
      error: null,
      notification: {
        type: 'info',
        message: ''
      },
      isNew: false
    };
  },
  created() {
    this.fetchSanmer();
  },
  methods: {
    fetchSanmer() {
      if (!this.$route.params.id) {
        this.sanmer = {};
        return (this.isNew = true);
      }

      SanmerService.get(this.$route.params.id).then(
        response => (this.sanmer = response.data.data)
      );
    },
    async save() {
      try {
        await SanmerService.save(this.sanmer.id, this.sanmer);

        this.notification.type = 'success';
        this.notification.message = 'Saneerder opgeslagen';

        return this.$router.push({ name: 'sanmers' });
      } catch (response) {
        this.error = response.data;

        this.notification.type = 'error';
        this.notification.message = 'Saneerder niet opgeslagen';
      }
    },
    async destroy() {
      if (confirm('Weet u zeker dat u deze saneerder wilt verwijderen??')) {
        try {
          await SanmerService.delete(this.sanmer.id);
          return this.$router.push({ name: 'sanmers' });
        } catch (response) {
          this.error = response.data;

          this.notification.type = 'error';
          this.notification.message = 'Saneerder niet verwijderd.';
        }
      }
    }
  }
};
</script>
